<template>
  <MainLayout>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <template v-for="tab in tabs">
        <v-tab :key="tab.name" :to="{ name: tab.name }" ripple>{{ $t(tab.label) }}</v-tab>
      </template>
    </v-tabs>
    <router-view></router-view>
  </MainLayout>
</template>

<script>
export default {
  data() {
    return {
      currentView: 'survey',
      tabs: [
        {
          name: 'survey',
          label: 'survey'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/survey/LayoutSurvey.vue